import { accountsApiRtkQuery } from '@chillibean/accounts-api-client-sdk';
import { trialContainersApiRtkQuery } from '@chillibean/trial-containers-api-client-sdk';
import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { apiSlice } from './apiSlice';
import { internalReducer } from './internal.slice';
import { userActivityReducer } from './userActivity.slice';

const accountsSlice = accountsApiRtkQuery.baseApi;
const trialContainersSlice = trialContainersApiRtkQuery.baseApi;

const rootReducer = combineReducers({
  internalReducer: internalReducer,
  userActivityReducer: userActivityReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
  [accountsSlice.reducerPath]: accountsSlice.reducer,
  [trialContainersSlice.reducerPath]: trialContainersSlice.reducer,
});

const setupStore = (preloadedState) =>
  configureStore({
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(apiSlice.middleware, accountsSlice.middleware, trialContainersSlice.middleware),
    preloadedState: preloadedState,
    reducer: rootReducer,
  });

export default setupStore;
